/* AGENT PROFILES */
export const GET_AGENT_PROFILE = "GET_AGENT_PROFILE"
export const GET_AGENT_PROFILE_SUCCESS = "GET_AGENT_PROFILE_SUCCESS"
export const GET_AGENT_PROFILE_ERROR = "GET_AGENT_PROFILE_ERROR"

export const GET_AGENT_PROFILE_POPUP_MESSAGE = "GET_AGENT_PROFILE_POPUP_MESSAGE"
export const GET_AGENT_PROFILE_POPUP_MESSAGE_SUCCESS = "GET_AGENT_PROFILE_POPUP_MESSAGE_SUCCESS"
export const GET_AGENT_PROFILE_POPUP_MESSAGE_ERROR = "GET_AGENT_PROFILE_POPUP_MESSAGE_ERROR"

export const MODIFY_AGENT_PROFILE = "MODIFY_AGENT_PROFILE"
export const MODIFY_AGENT_PROFILE_SUCCESS = "MODIFY_AGENT_PROFILE_SUCCESS"
export const MODIFY_AGENT_PROFILE_ERROR = "MODIFY_AGENT_PROFILE_ERROR"

export const UPLOAD_AGENT_PROFILE_IMAGES = "UPLOAD_AGENT_PROFILE_IMAGES"
export const UPLOAD_AGENT_PROFILE_IMAGES_SUCCESS = "UPLOAD_AGENT_PROFILE_IMAGES_SUCCESS"
export const UPLOAD_AGENT_PROFILE_IMAGES_ERROR = "UPLOAD_AGENT_PROFILE_IMAGES_ERROR"

export const GET_QUOTE_FUNNELS = "GET_QUOTE_FUNNELS"
export const GET_QUOTE_FUNNELS_SUCCESS = "GET_QUOTE_FUNNELS_SUCCESS"
export const GET_QUOTE_FUNNELS_ERROR = "GET_QUOTE_FUNNELS_ERROR"

export const MODIFY_QUOTE_FUNNEL = 'MODIFY_QUOTE_FUNNEL'
export const MODIFY_QUOTE_FUNNEL_SUCCESS = 'MODIFY_QUOTE_FUNNEL_SUCCESS'
export const MODIFY_QUOTE_FUNNEL_ERROR = 'MODIFY_QUOTE_FUNNEL_ERROR'

export const CREATE_DEFAULT_QUOTE_FUNNELS = 'CREATE_DEFAULT_QUOTE_FUNNELS'
export const CREATE_DEFAULT_QUOTE_FUNNELS_SUCCESS = 'CREATE_DEFAULT_QUOTE_FUNNELS_SUCCESS'
